"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFieldWithFormikContext = void 0;
var _hooks = require("../../state/redux/hooks");
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _sdk = require("../../../sdk");
var _FieldWrapper = require("../FieldWrapper");
var _issueCustomFields = require("../../state/redux/ducks/issueCustomFields");
var _alloyReactTextarea = _interopRequireDefault(require("@adsk/alloy-react-textarea"));
var _alloyReactTextInput = _interopRequireDefault(require("@adsk/alloy-react-text-input"));
var _IssueCustomListDropdown = require("../IssueCustomListDropdown");
var _useTranslations = require("../../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomFieldWithFormikContext = _ref => {
  let {
    attributeDefinitionId,
    isRequired,
    container
  } = _ref;
  const {
    values,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    touched,
    errors,
    submitCount
  } = (0, _formik.useFormikContext)();
  const issueCustomFieldEntitiesMap = (0, _hooks.useSelector)(_issueCustomFields.getCustomFieldEntitiesMap);
  const attribute = issueCustomFieldEntitiesMap[attributeDefinitionId];
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  if (!attribute) {
    return null;
  }
  const fieldPath = "customAttributes.".concat(attributeDefinitionId);
  const errorMessage = ((0, _formik.getIn)(touched, ["customAttributes", attributeDefinitionId]) || submitCount > 0) && (0, _formik.getIn)(errors, ["customAttributes", attributeDefinitionId]);

  // When we pass the children from FieldWrapper to FormField here, we use an object and apply [customField.dataType] to it.
  // We don't use a function with switch/case because the function wouldn't end up returning the component
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: attribute.title,
    errorMessage: errorMessage,
    required: isRequired
  }, {
    [_sdk.IssueCustomAttributeType.List]: /*#__PURE__*/_react.default.createElement(_IssueCustomListDropdown.IssueCustomListDropdown, {
      fieldPath: fieldPath,
      error: !!errorMessage,
      attribute: attribute,
      onChange: value => {
        /**
         * For whatever reason, setting the value via the field path
         * does not let that value get immediately used for validation.
         *
         * So, either we do something like:
         * ```
         * setFieldValue("customAttributes", {
         *   ...values.customAttributes,
         *   [attributeDefinitionId]: value,
         * });
         * ```
         *
         * or we use setTimeout to defer the validation until after the fieldPath modification
         * gets taken into account for validation.
         *
         * Without this, the first time the user changes a custom attribute, it will say "required"
         * event though they just changed it.
         *
         * We're taking the latter approach for now to stay consistent with the use of fieldPath
         * elsewhere in this module.
         *
         */
        setFieldValue(fieldPath, value, /* shouldValidate: */false);
        window.setTimeout(() => {
          setFieldTouched(fieldPath, true);
        }, 0);
      },
      required: isRequired,
      value: (0, _formik.getIn)(values, fieldPath),
      container: container,
      "data-testid": "create-issue-modal-customattribute-".concat(attributeDefinitionId)
    }),
    [_sdk.IssueCustomAttributeType.Text]: /*#__PURE__*/_react.default.createElement(_alloyReactTextInput.default, {
      placeholder: T.translate("customFieldsAdmin.placeholder.text"),
      name: fieldPath,
      autoComplete: "off",
      value: (0, _formik.getIn)(values, fieldPath),
      onChange: handleChange,
      onBlur: handleBlur,
      error: !!errorMessage,
      "data-testid": "create-issue-modal-customattribute-".concat(attributeDefinitionId)
    }),
    [_sdk.IssueCustomAttributeType.Numeric]: /*#__PURE__*/_react.default.createElement(_alloyReactTextInput.default, {
      placeholder: T.translate("customFieldsAdmin.placeholder.numeric"),
      name: fieldPath,
      autoComplete: "off",
      value: (0, _formik.getIn)(values, fieldPath),
      onChange: handleChange,
      onBlur: handleBlur,
      error: !!errorMessage,
      "data-testid": "create-issue-modal-customattribute-".concat(attributeDefinitionId)
    }),
    [_sdk.IssueCustomAttributeType.Paragraph]: /*#__PURE__*/_react.default.createElement(_alloyReactTextarea.default, {
      style: {
        width: "100%"
      },
      placeholder: T.translate("customFieldsAdmin.placeholder.text")
      // @ts-ignore https://jira.autodesk.com/browse/DSGN-661
      ,
      name: fieldPath,
      autoComplete: "off",
      value: (0, _formik.getIn)(values, fieldPath),
      onChange: handleChange,
      onBlur: handleBlur,
      minHeight: 70,
      maxHeight: 70,
      error: !!errorMessage,
      "data-testid": "create-issue-modal-customattribute-".concat(attributeDefinitionId)
    }),
    [_sdk.IssueCustomAttributeType.Date]: null,
    [_sdk.IssueCustomAttributeType.Checkbox]: null
  }[attribute.dataType]);
};
exports.CustomFieldWithFormikContext = CustomFieldWithFormikContext;
//# sourceMappingURL=CustomFieldWithFormikContext.js.map